export default "__VITE_ASSET__BPDfe7dG__"